import React, { useEffect, useState } from 'react';
import { partnersApi, eventsApi } from '../services/api';
import ImageUploader from '../components/ImageUploader';

const EMPTY = {
  type: 'hotel', name: '', description_it: '', description_en: '', description_de: '',
  city: '', address: '', latitude: '', longitude: '', phone: '', email: '',
  website: '', image_url: '', price_range: '€€', rating: '', is_sponsored: false,
  sponsored_priority: 0, event_id: '',
};

export default function PartnersPage() {
  const [partners, setPartners] = useState([]);
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filterType, setFilterType] = useState('hotel');

  const load = () => {
    partnersApi.list({ type: filterType }).then((r) => setPartners(r.data)).catch(() => {});
  };

  useEffect(() => {
    eventsApi.list().then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [filterType]);

  const save = async (e) => {
    e.preventDefault();
    try {
      const data = { ...form, rating: form.rating ? parseFloat(form.rating) : null, event_id: form.event_id || null };
      if (editing) {
        await partnersApi.update(editing, data);
      } else {
        await partnersApi.create(data);
      }
      setShowForm(false);
      setEditing(null);
      setForm(EMPTY);
      load();
    } catch (err) {
      alert('Erro: ' + err.message);
    }
  };

  const del = async (id) => {
    if (!window.confirm('Excluir parceiro?')) return;
    await partnersApi.delete(id);
    load();
  };

  const f = (key) => (e) => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm((p) => ({ ...p, [key]: val }));
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h2 style={styles.title}>Hotéis & Restaurantes</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <select style={styles.select} value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="hotel">Hotéis</option>
            <option value="restaurant">Restaurantes</option>
          </select>
          <button style={styles.btnPrimary} onClick={() => { setForm({ ...EMPTY, type: filterType }); setEditing(null); setShowForm(true); }}>
            + Novo
          </button>
        </div>
      </div>

      {showForm && (
        <form onSubmit={save} style={styles.formCard}>
          <h3>{editing ? 'Editar' : 'Novo'} {form.type === 'hotel' ? 'Hotel' : 'Restaurante'}</h3>
          <div style={styles.grid2}>
            <label>Tipo
              <select style={styles.input} value={form.type} onChange={f('type')}>
                <option value="hotel">Hotel</option>
                <option value="restaurant">Restaurante</option>
              </select>
            </label>
            <label>Nome<input style={styles.input} value={form.name} onChange={f('name')} required /></label>
            <label>Cidade<input style={styles.input} value={form.city} onChange={f('city')} required /></label>
            <label>Endereço<input style={styles.input} value={form.address} onChange={f('address')} /></label>
            <label>Telefone<input style={styles.input} value={form.phone} onChange={f('phone')} /></label>
            <label>Email<input style={styles.input} type="email" value={form.email} onChange={f('email')} /></label>
            <label>Website<input style={styles.input} value={form.website} onChange={f('website')} /></label>
            <div style={{ gridColumn: '1 / -1' }}>
              <ImageUploader
                label="Imagem"
                value={form.image_url}
                onChange={(url) => setForm((p) => ({ ...p, image_url: url }))}
              />
            </div>
            <label>Preço
              <select style={styles.input} value={form.price_range} onChange={f('price_range')}>
                <option>€</option><option>€€</option><option>€€€</option><option>€€€€</option>
              </select>
            </label>
            <label>Rating (0-5)<input style={styles.input} type="number" step="0.1" min="0" max="5" value={form.rating} onChange={f('rating')} /></label>
            <label>Latitude<input style={styles.input} type="number" value={form.latitude} onChange={f('latitude')} /></label>
            <label>Longitude<input style={styles.input} type="number" value={form.longitude} onChange={f('longitude')} /></label>
            <label>Vincular ao evento
              <select style={styles.input} value={form.event_id} onChange={f('event_id')}>
                <option value="">Todos os eventos</option>
                {events.map((ev) => <option key={ev.id} value={ev.id}>{ev.name} ({ev.date})</option>)}
              </select>
            </label>
            <label>Prioridade patrocínio<input style={styles.input} type="number" value={form.sponsored_priority} onChange={f('sponsored_priority')} /></label>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
            <input type="checkbox" checked={form.is_sponsored} onChange={f('is_sponsored')} />
            <strong>⭐ Parceiro patrocinado (aparece no topo)</strong>
          </label>
          <label>Descrição IT<textarea style={styles.textarea} value={form.description_it} onChange={f('description_it')} /></label>
          <label>Descrição EN<textarea style={styles.textarea} value={form.description_en} onChange={f('description_en')} /></label>
          <label>Descrição DE<textarea style={styles.textarea} value={form.description_de} onChange={f('description_de')} /></label>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button style={styles.btnPrimary} type="submit">Salvar</button>
            <button style={styles.btnSecondary} type="button" onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        </form>
      )}

      <table style={styles.table}>
        <thead>
          <tr>
            {['Nome', 'Cidade', 'Tipo', 'Preço', 'Rating', 'Patrocinado', 'Ações'].map((h) => (
              <th key={h} style={styles.th}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {partners.map((p) => (
            <tr key={p.id}>
              <td style={styles.td}>{p.name}</td>
              <td style={styles.td}>{p.city}</td>
              <td style={styles.td}>{p.type}</td>
              <td style={styles.td}>{p.price_range}</td>
              <td style={styles.td}>{p.rating || '—'}</td>
              <td style={styles.td}>{p.is_sponsored ? '⭐ Sim' : 'Não'}</td>
              <td style={styles.td}>
                <button style={styles.btnSmall} onClick={() => { setForm({ ...EMPTY, ...p, event_id: p.event_id || '' }); setEditing(p.id); setShowForm(true); }}>✏️</button>
                <button style={styles.btnSmall} onClick={() => del(p.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  page: { padding: 24 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  title: { margin: 0, color: '#1D3557' },
  select: { padding: '8px 12px', borderRadius: 7, border: '1px solid #ddd', fontSize: 14 },
  formCard: { background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20, boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 },
  input: { display: 'block', width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', marginTop: 4, fontSize: 14, boxSizing: 'border-box' },
  textarea: { display: 'block', width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', marginTop: 4, fontSize: 14, minHeight: 80, resize: 'vertical', boxSizing: 'border-box', marginBottom: 12 },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' },
  th: { background: '#1D3557', color: '#fff', padding: '10px 14px', textAlign: 'left', fontSize: 13 },
  td: { padding: '10px 14px', borderBottom: '1px solid #f0f0f0', fontSize: 13 },
  btnPrimary: { padding: '8px 18px', background: '#E63946', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 700 },
  btnSecondary: { padding: '8px 18px', background: '#eee', color: '#333', border: 'none', borderRadius: 7, cursor: 'pointer' },
  btnSmall: { padding: '4px 10px', background: '#eee', border: 'none', borderRadius: 5, cursor: 'pointer', marginRight: 4, fontSize: 12 },
};
